import { render, staticRenderFns } from "./UserMenuContent.vue?vue&type=template&id=3a8d68fa&scoped=true&"
import script from "./UserMenuContent.vue?vue&type=script&lang=js&"
export * from "./UserMenuContent.vue?vue&type=script&lang=js&"
import style0 from "./UserMenuContent.vue?vue&type=style&index=0&id=3a8d68fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a8d68fa",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
installComponents(component, {VListItem,VListItemContent})
